import AsyncComponent from '../../components/HOC/AsyncComponent';

const AsyncLoanApplications = AsyncComponent(() => import('./Solicitudes'));

export { AsyncLoanApplications };



// WEBPACK FOOTER //
// ./src/tables/reactable/index.js